<template>
    <div id="triangleImage">
        <h1 id="descBottom">{{ description }}</h1>
        <!--<h1 id="descLeft">{{ description }}</h1>
        <h1 id="descRight">{{ description }}</h1>-->
    </div>
</template>

<script>
export default {
    name: 'Card',
    props: {
        description: String,
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body, #descBottom, #descLeft, #descRight {
    margin: 0px;
    padding: 0px;
}

#descBottom, #descLeft, #descRight {
    font-size: 16px;
}

#triangleImage {
    position: relative;
    background-image: url('../assets/card.png');
    background-size: cover;
    margin: 20px;
    padding: 0px;
    left: 0px;
    width: 210px;
    height: 182px;
    display: inline-block;
    cursor: default;
    user-select: none;
}

@font-face {
  font-family: 'montserrat';
  src: url('../assets/fonts/Montserrat-Light.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

#descBottom {
    position: relative;
    font-family: "montserrat";
    top: 153px;
}

#descLeft {
    position: relative;
    transform: rotate(120deg);
    top: 70px;
    left: -40px;
}

#descRight {
    position: relative;
    transform: rotate(240deg);
    top: 45px;
    left: 39px;
}

</style>
